import React, { useState } from "react";
import "./DirectorMessage.css";

const DirectorMessage = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="director-container">
      {/* Director's Message Section */}
      <div className="message-box">
        <h2 className="section-title">DIRECTOR'S MESSAGE</h2>
        <div className="image-container">
          <img src="/images/Director.jpeg" alt="Director" className="director-image" />
        </div>
        <p className="text">
          Welcome to <strong>RDTC Singawal</strong>, where we are committed to shaping responsible, skilled, and confident drivers for the future. At our driving training center, we believe that road safety, discipline, and expertise are the cornerstones of a responsible driver.
        </p>
        {expanded && (
          <>
            <p className="text">
              Our institution is dedicated to providing <strong>comprehensive driving education</strong>, integrating modern training techniques, and ensuring that every learner gains the necessary knowledge to drive safely and responsibly. With our <strong>experienced instructors, advanced infrastructure, and government-approved courses</strong>, we take pride in equipping our students with the skills and confidence required to navigate the roads efficiently.
            </p>
            <p className="text">
              As the <strong>Director of RDTC Singawal</strong>, my vision is to <strong>create safer roads by training competent drivers</strong> who understand the importance of traffic rules, vehicle control, and responsible driving behavior.
            </p>
            <p className="text">
              Join us on this journey toward safer and more responsible driving. <strong>Let’s make the roads safer—one trained driver at a time!</strong>
            </p>
          </>
        )}
        <button className="read-more" onClick={() => setExpanded(!expanded)}>
          {expanded ? "Read less" : "Read more"}
        </button>
        <p className="quote">
          "We cannot always build the future for our youth, but we can build our youth for the future."
        </p>
      </div>

      {/* About RTDC Section */}
      <div className="about-box">
        <h2 className="section-title">ABOUT RTDC</h2>
        <div className="video-container">
          <h3 className="sub-title">RTDC TOUR</h3>
          <iframe
            className="video-frame"
            height="200"
            src="Videos/RTDC.mp4"
            title="RTDC Tour"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div className="info-sections">
          <details>
            <summary>Administration</summary>
            <p>"Ensuring smooth operations, strategic planning, and effective management of resources for organizational success."</p>
          </details>
          <details>
            <summary>About Us</summary>
            <p>"Dedicated to excellence, innovation, and community growth through Training and Program."</p>
          </details>
          <details>
            <summary>Driving Track</summary>
            <p>"A state-of-the-art driving track designed for safe and effective training experiences."</p>
          </details>
        </div>
      </div>
    </div>
  );
};

export default DirectorMessage;
